import { render, staticRenderFns } from "./ColonyList.vue?vue&type=template&id=3ae36d2e&scoped=true&"
import script from "./ColonyList.vue?vue&type=script&lang=js&"
export * from "./ColonyList.vue?vue&type=script&lang=js&"
import style0 from "./ColonyList.vue?vue&type=style&index=0&id=3ae36d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae36d2e",
  null
  
)

export default component.exports